

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"20"}, rest), [h('path', {"fill":"#262626","d":"M6.15 0H1.46a.821.821 0 0 0-.82.82v18.36c0 .442.357.82.82.82h4.67a.82.82 0 0 0 .82-.82V.82a.804.804 0 0 0-.8-.82Zm10.747 0h-4.69a.821.821 0 0 0-.82.82v18.36c0 .442.357.82.82.82h4.669c.441 0 .82-.357.82-.82V.82a.804.804 0 0 0-.8-.82Z"}, [])]);
};

        